import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist';

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
})

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  plugins: [vuexLocalStorage.plugin],
  state: {
    user:null,
    currency:'',
    currText:'$',
    cart: [],
    order: {},
    contact:{},
    colors: {
      pure: [
        {
          name: "White",
          color: "#fff",
          type: "color"
        },
        {
          name: "Aqua",
          color: "#00fefe",
          type: "color"
        },
        {
          name: "Neon Green",
          color: "#22ef53",
          type: "color"
        },
        {
          name: "Hot Pink",
          color: "#e92dee",
          type: "color"
        },
        {
          name: "Yellow",
          color: "#fefe1f",
          type: "color"
        },
        {
          name: "Maroon",
          color: "#ca0238",
          type: "color"
        },
        {
          name: "Grey",
          color: "#959595",
          type: "color"
        },
        {
          name: "Navy",
          color: "#172c8f",
          type: "color"
        },
        {
          name: "Red",
          color: "#fe0302",
          type: "color"
        },
        {
          name: "Purple",
          color: "#80047f",
          type: "color"
        },
        {
          name: "Orange",
          color: "#fea410",
          type: "color"
        },
        {
          name: "Green",
          color: "#007f0a",
          type: "color"
        },
        {
          name: "Dark Grey",
          color: "#484848",
          type: "color"
        },
        {
          name: "Blue",
          color: "#130ffd",
          type: "color"
        },
        {
          name: "Lime",
          color: "#c5e94b",
          type: "color"
        },
        {
          name: "Black",
          color: "#000000",
          type: "color"
        }
      ],
      camos: [{
          name: "whitecamo",
          type: "camo"
        },
        {
          name: "bluecamo",
          type: "camo"
        },
        {
          name: "greencamo",
          type: "camo"
        },
        {
          name: "pinkcamo",
          type: "camo"
        },
        {
          name: "triangles",
          type: "camo"
        }
      ],
      prints: [{
          "name": "1",
          "type": "print",
        },
        {
          "name": "2",
          "type": "print",
        },
        {
          "name": "3",
          "type": "print",
        },
        {
          "name": "4",
          "type": "print",
        },
        {
          "name": "5",
          "type": "print",
        },
        {
          "name": "6",
          "type": "print",
        },
        {
          "name": "7",
          "type": "print",
        },
        {
          "name": "8",
          "type": "print",
        },
        {
          "name": "9",
          "type": "print",
        },
        {
          "name": "10",
          "type": "print",
        },
        {
          "name": "11",
          "type": "print",
        },
        {
          "name": "12",
          "type": "print",
        },
        {
          "name": "13",
          "type": "print",
        },
        {
          "name": "14",
          "type": "print",
        },
        {
          "name": "5",
          "type": "print",
        },
        {
          "name": "16",
          "type": "print",
        },
        {
          "name": "17",
          "type": "print",
        },
      ]
    },
  },
  getters: {
    itemsInCart(state) {
      return state.cart;
    },
    colors(state) {
      return state.colors;
    },
    user(state) {
      return state.user;
    },
    currency(state){
      return state.currency;
    },
    currText(state){
      return state.currText;
    },
    contact(state){
      return state.contact;
    },
    totalprice(state) {
      return state.cart.reduce((total, item) => {
        return total + item.price
      }, 0)
    }
  },
  mutations: {
    contact(state,payload){
      console.log(payload)
      state.contact = payload;
    },
    deleteCartItem(state, payload) {
      var itemIndex = state.cartitems.findIndex(p => p._id === payload._id)
      state.cart.splice(itemIndex, 1)
    },
    addProductToCart(state, product) {
      state.cart.push(product)
    },
    addMeasurements(state, payload) {
      state.order.measurements = payload.measurements;
    },
    addMaterials(state, payload) {
      state.order.materials = payload.materials;
    },
    addSuits(state, payload) {
      state.order.suits = payload.suits;
      state.order.price = payload.price;
      state.order.name = payload.name;
      state.order.colorlist = payload.colorlist;
    },
    addOrder(state) {
      state.cart.push(state.order);
      state.order = {}
    },
    removeFromCart(state,payload) {
      let item = payload.payload.item;
      let index = state.cart.indexOf(item);
      state.cart.splice(index,1);
    },
    clearFromCart(state) {
      state.cart = [];
    },
    setAdminState(state,payload){
      state.user=payload.payload.user;
    },
    removeAdminState(state){
      state.user=null;
    },
    addons(state,payload){
      state.order.price = payload.price;
      state.order.addons = payload.addons;
      state.order.note = payload.note;
    },
    setCurrencyState(state, payload){
      state.currency = payload.payload.item;
      state.currText = payload.payload.text;
    }
  },
  actions: {
    setCurrency({ commit }, payload){
      commit({
        type: 'setCurrencyState',
        payload
      })
    },
    clear({
      commit
    }) {
      commit({
        type: 'clearFromCart',
      })
    },
    setAdmin({commit},payload){
      commit({
        type: 'setAdminState',
        payload
      })
    },
    removeAdmin({commit},payload){
      commit({
        type: 'removeAdminState',
        payload
      })
    },
    deleteCartItem({
      commit
    }, payload) {
      commit({
        type: 'removeFromCart',
        payload
      })
    },
    addToCart({
      commit
    }) {
      commit({
        type: 'addOrder',
      })
    },
    suits({
      commit
    }, payload) {
      commit({
        type: 'addSuits',
        suits: payload.suits,
        price: payload.price,
        name: payload.name,
        colorlist:payload.colorlist,
      })
    },
    addons({
      commit
    }, payload) {
      commit({
        type: 'addons',
        price: payload.price,
        addons: payload.addons,
        note:payload.note
      })
    },
    measurements({
      commit
    }, payload) {
      commit({
        type: 'addMeasurements',
        measurements: payload.measurements
      })
    },
    materials({
      commit
    }, payload) {
      commit({
        type: 'addMaterials',
        materials: payload.materials
      })
    }
  }
})